'use strict';

const Flights = require('../../apps/app.flights');

module.exports = Odigeo.Model.extend({
    defaultParams: {
        landingPageType: 'PASSENGER',
        searchMainProductTypeName: 'FLIGHT',
        utm_medium: 'crm',
        utm_source: 'sg',
        utm_campaign: 't',
        utm_term: 'share_flight',
        mktportal: 'T',
    },
    utmParams: {
        telesales: {
            utm_term: 'share_flight_telesales',
        },
        whatsApp: {
            utm_term: 'searchreminder_flight_whatsapp',
        },
    },
    keyMap: {
        searchId: 'searchId',
        fareItineraryKey: 'fareItineraryKey',
    },

    init: function() {
        this.set('linkType', Odigeo.SessionScope.mktPortal.toLowerCase() === 'telesales' ? 'telesales' : 'shareLink');
        this.searchdataPromise = this.setShareLink();
    },

    addSegmentKeys: function(segments) {
        return Odigeo._.reduce(segments, function(result, values, key) {
            result['segmentKey' + key] = values;
            return result;
        }, {});
    },

    addShareParams: function() {
        return {
            sharePrice: this.widget.options.price,
        };
    },

    parseSelectionLinkParams: function(data, params, hasDecodeUri) {
        var selectionParams = Odigeo._.extend({}, this.defaultParams, params,
            Odigeo._.pick(data, Odigeo._.keys(this.keyMap)),
            this.addSegmentKeys(data.flightNumbers ? data.flightNumbers : data.segmentKeys),
            this.addShareParams());
        return '?' + (hasDecodeUri ? decodeURIComponent($.param(selectionParams)) : $.param(selectionParams));
    },

    parseSearchdata: function(data) {
        this.buildlinks(data, data.externalSelectionRequest);
    },

    getLink: function(searchData, selection, params, hasDecodeUri) {
        return location.protocol + '//' + Flights.getPath({
            searchParams: Flights.searchParamsStringify(searchData),
            flightData: this.parseSelectionLinkParams(selection, params, hasDecodeUri),
            page: 'results',
        });
    },

    buildlinks: function(searchData, selection) {
        this.set({
            'shareLink': this.getLink(searchData, selection, null, true),
            'shareLinkWhatsapp': encodeURIComponent(this.getLink(searchData, selection, this.utmParams.whatsApp, false)),
            'telesales': this.getLink(searchData, selection, this.utmParams.telesales, true),
        });
    },

    setShareLink: function() {
        var selectionData;
        if (!Odigeo._.isNull(Odigeo.Session.get('flightSelectionData'))) {
            selectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData')) || {};
            return Promise.resolve(this.buildlinks(Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')), selectionData.data));
        } else {
            return Flights.getSearchData().then(Odigeo._.bind(this.parseSearchdata, this));
        }
    },
});
